import styled from 'styled-components';

export const Container = styled.div`
  .hefesto-link {
    text-decoration: underline;
  }
  & nav > .hefesto-breadcrumbs {
    margin-bottom: 0;

    .hefesto-link__item {
      color: #0069ac !important;
    }
  }
`;
